// Considered: naming this a Molecule (the spec/plan text calls it
// "ComposerSpherePickerMolecule") — rejected because it wraps `SphereSelectDialogOrganism`, and
// molecule-imports-organism is a hard atomic-design Rule 2 violation. `DeployTargetDialogOrganism`
// wraps the same organism and is correctly tiered as an Organism; this follows that precedent
// (EAINT-844 Phase 2 tiering correction, mirroring the plan's own `ComposerCanvasOrganism` fix).
import React, { useCallback } from 'react';
import type { SphereSearchResult } from '../../../hooks/useSphereSearch';
import SphereSelectDialogOrganism from '../marketplace/SphereSelectDialogOrganism';
import './ComposerSpherePickerOrganism.scss';

export interface ComposerSpherePickerOrganismProps {
  open: boolean;
  onClose: () => void;
  titleKey?: string;
  subtitleKey?: string;
  /**
   * Fires with the picked sphere. Composer-local: this component never dispatches `setSphereId`
   * to Redux and never navigates — the caller owns what happens next with the pick (SC4).
   */
  onPick: (sphere: SphereSearchResult) => void;
  excludedSphereIds?: string[];
}

const ComposerSpherePickerOrganism: React.FC<ComposerSpherePickerOrganismProps> = ({
  open,
  onClose,
  titleKey = 'composer.spherePicker.title',
  subtitleKey,
  onPick,
  excludedSphereIds,
}) => {
  const handleSelect = useCallback(
    (sphere: SphereSearchResult): boolean => {
      onPick(sphere);
      return true;
    },
    [onPick]
  );

  return (
    <SphereSelectDialogOrganism
      open={open}
      onClose={onClose}
      titleKey={titleKey}
      subtitleKey={subtitleKey}
      onSelect={handleSelect}
      excludedSphereIds={excludedSphereIds}
    />
  );
};

export default ComposerSpherePickerOrganism;
